import $ from 'jquery';

let hideTimeout = null;
const HIDE_DELAY = 200; // milliseconds delay before hiding

function toggleAllNavs() {
	$('html').removeClass('mega-nav-shown');
	$('.header-wrap li a.active, .scrolled-header-wrap li a.active').removeClass('active');
	$('.mega-nav.active').removeClass('active');
}

function showMegaNav(menuItem, navClass) {
	// Clear any pending hide timeout
	if (hideTimeout) {
		clearTimeout(hideTimeout);
		hideTimeout = null;
	}

	// Hide all navs first
	toggleAllNavs();

	// Show the selected nav
	$('html').addClass('mega-nav-shown');
	menuItem.addClass('active');
	$(navClass).addClass('active');
}

function scheduleHideNavs() {
	// Clear any existing timeout
	if (hideTimeout) {
		clearTimeout(hideTimeout);
	}

	// Schedule hide after delay
	hideTimeout = setTimeout(function() {
		toggleAllNavs();
		hideTimeout = null;
	}, HIDE_DELAY);
}

function cancelHideNavs() {
	if (hideTimeout) {
		clearTimeout(hideTimeout);
		hideTimeout = null;
	}
}

function setupMegaNavHover(menuSelector, navClass) {
	const $menuLink = $(menuSelector);
	const $menuItem = $menuLink.closest('li'); // Get parent li element
	const $megaNav = $(navClass);

	// Show on hover over menu item (both link and parent li)
	$menuItem.add($menuLink).on('mouseenter', function() {
		showMegaNav($menuLink, navClass);
	});

	// Schedule hide when leaving menu item
	$menuItem.on('mouseleave', function() {
		scheduleHideNavs();
	});

	// Cancel hide and keep visible when hovering over meganav
	$megaNav.on('mouseenter', function() {
		cancelHideNavs();
	});

	// Schedule hide when leaving meganav
	$megaNav.on('mouseleave', function() {
		scheduleHideNavs();
	});
}

function tbxHandleMegaNavs() {
	// Remove click handler on body that was closing navs
	// Keep it for mobile/accessibility if needed, but prevent it from interfering
	$('body').on('click', function(e) {
		// Only close if clicking outside the header and meganav
		if (!$(e.target).closest('.header-wrap, .mega-nav').length) {
			toggleAllNavs();
		}
	});

	$('.mega-nav').on('click', function(e) {
		e.stopPropagation();
	});

	// Setup hover behavior for each meganav
	setupMegaNavHover('.header-wrap .toggle-academic-programs-meganav a', '.mega-nav.academic-programs');
	setupMegaNavHover('.header-wrap .toggle-admissions-meganav a', '.mega-nav.admissions');
	setupMegaNavHover('.header-wrap .toggle-tuition-meganav a', '.mega-nav.tuition');
	setupMegaNavHover('.header-wrap .toggle-experience-meganav a', '.mega-nav.student-experience');
	setupMegaNavHover('.header-wrap .toggle-online-meganav a', '.mega-nav.online');

	// Handle mega nav link clicks - close when a link is clicked
	$('.mega-nav a').on('click', function() {
		toggleAllNavs();
	});
}

export default tbxHandleMegaNavs;